"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _params = require("hub-http/helpers/params");

var API_BASE = 'reports/v1/onboarding';

var OnboardingAPI =
/*#__PURE__*/
function () {
  function OnboardingAPI() {
    (0, _classCallCheck2.default)(this, OnboardingAPI);
  }

  (0, _createClass2.default)(OnboardingAPI, null, [{
    key: "sendTrackingCode",
    value: function sendTrackingCode(recipient) {
      return _apiClient.default.post(API_BASE + "/tracking-code", {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: (0, _params.stringify)({
          recipient: recipient
        })
      });
    }
  }]);
  return OnboardingAPI;
}();

exports.default = OnboardingAPI;
module.exports = exports.default;